<template>
  <span v-if="membership && membership.is_admin" />
  <button
    v-else-if="membership && membership.status === 'request'"
    class="btn btn-primary"
    @click.prevent="handleSubmit"
  >
    Cancel Join
  </button>
  <button
    v-else-if="membership && membership.status === 'rejected'"
    class="btn btn-primary"
    disabled
    @click.prevent="handleSubmit"
  >
    Rejected
  </button>
  <button
    v-else-if="userData && ! membership || membership.status !== 'banned'"
    class="btn btn-primary"
    :disabled="submitting"
    @click.prevent="handleSubmit"
  >
    {{ isMember ? "Leave" : "Join" }}
  </button>
</template>

<script>
export default {
  name: 'JoinGroupButton',
  props: {
    group: { type: Number, required: true },
  },
  data() {
    return {
      submitting: false,
    };
  },
  computed: {
    membership() {
      return this.userGroups.find(g => g.id === this.group);
    },
    isMember() {
      return this.membership && this.membership.status === 'active';
    },
  },
  methods: {
    async handleSubmit() {
      const url = this.membership
        ? `groups/${this.group}/leave/`
        : `groups/${this.group}/request_membership/`;
      const response = await this.api({ url, method: 'POST' });
      if (response.ok) {
        const groups = this.userGroups.slice();
        const idx = groups.findIndex(g => g.id === this.group);
        if (this.membership) {
          groups.splice(idx, 1);
        } else if (idx === -1) {
          groups.push({
            id: this.group,
            status: response.body.status,
          });
        } else {
          groups[idx].status = response.body.status;
        }
        this.$store.commit('userGroups', groups);
        // TODO: add/remove group
      }
    },
  },
};
</script>
